import React, { FC } from 'react';
import SafePerfectScrollbar from 'components/SafePerfectScrollbar';
import { TopMenuItem } from 'dashboard409a/components';
import { ListContainer, RootContainer } from './styles';
import { ITopMenu } from './types';

// TODO: Test perfect scroll on page
const TopMenu: FC<ITopMenu> = props => {
  const { items } = props;

  return (
    <SafePerfectScrollbar options={{ suppressScrollX: true, wheelPropagation: false, wheelSpeed: 3 }}>
      <RootContainer>
        {items.length > 0 && (
          <ListContainer>
            {items.map(menuItem => (
              <TopMenuItem item={menuItem} key={menuItem.slug} />
            ))}
          </ListContainer>
        )}
      </RootContainer>
    </SafePerfectScrollbar>
  );
};

export default TopMenu;
